const EVENT_STATUS = {
    canceled: 'Canceled',
    completed: 'Completed',
    in_progress: 'In Progress',
};

export default EVENT_STATUS;
